import { cn as e } from "../shared/utils.js";
import { Toggle as t } from "./primitive/index.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/toggle/toggle-control.tsx
function i({ className: i, rootClassName: a, disabled: o, label: s, labelProps: c, thumbProps: l, ...u }) {
	return /* @__PURE__ */ r("label", {
		className: e("text-text-primary inline-flex min-w-0 items-center gap-2 text-base font-normal", o ? "text-text-disabled cursor-not-allowed" : "cursor-pointer", a),
		children: [/* @__PURE__ */ n(t.Root, {
			...u,
			className: i,
			disabled: o,
			children: /* @__PURE__ */ n(t.Thumb, {
				...l,
				className: l?.className
			})
		}), !!s && /* @__PURE__ */ n("span", {
			...c,
			className: e("min-w-0 leading-5", c?.className),
			children: s
		})]
	});
}
//#endregion
export { i as ToggleControl };
